import moment from 'moment'
import { FileProperty, TalkTalker, TalkProperties } from '@/infrastructure/network/Monitaro/schema/models'

export interface ITalkProps {
  id?: string
  roomId: string
  talkerId: string | null
  talkerType: string
  readsCount: number
  message: string | null
  deleted: boolean
  system: boolean
  files?: FileProperty[] | null
  data?: File[] | null
  createdAt: string | null
  updatedAt: string | null
  talker?: TalkTalker
  properties?: TalkProperties | null
}

export interface IBulkTalkProps {
  doctors: string[]
  message?: string | null
  files?: File[]
}

export default class TalkEntity {
  private _props: ITalkProps

  constructor(props?: ITalkProps | null) {
    this._props = EmptyTalkPropsFactory(props)
  }

  get props(): ITalkProps {
    return this._props
  }

  get clone(): ITalkProps {
    return structuredClone(this._props)
  }

  get id(): string | undefined {
    return this._props.id
  }

  get roomId(): string {
    return this._props.roomId
  }

  get talkerId(): string | null {
    return this._props.talkerId
  }

  get talkerType(): string {
    return this._props.talkerType
  }

  get reads(): string {
    return this._props.readsCount > 0 ? '既読' : ''
  }

  get readsCount(): string | number {
    return this._props.readsCount > 0 ? this._props.readsCount : ''
  }

  get message(): string | null {
    return this._props.message
  }

  get hasFile(): boolean {
    return !!this._props.files?.find((file) => file.filename)
  }

  get files(): FileProperty[] {
    return this._props.files ?? []
  }

  get createdAt(): string | null {
    return moment(this._props.createdAt).format('HH:mm')
  }

  get updatedAt(): string | null {
    return this._props.updatedAt
  }

  get talker(): TalkTalker | undefined {
    return this._props.talker
  }

  get properties(): TalkProperties | null | undefined {
    return this._props.properties
  }

  get date(): string {
    return moment(this._props.createdAt).format('YYYY年M月D日')
  }

  get time(): string {
    return moment(this._props.createdAt).format('H:mm')
  }

  get deleted(): boolean {
    return this._props.properties?.delete || false
  }
}

export const headers = [{ text: 'ID', value: 'id' }]

export const EmptyTalkPropsFactory = (props?: Partial<ITalkProps> | null): ITalkProps => ({
  roomId: '',
  talkerId: '',
  talkerType: '',
  readsCount: 0,
  deleted: false,
  system: false,
  message: null,
  createdAt: null,
  updatedAt: null,
  ...props
})
